/* Hawcrest – Gift Finder (vanilla JS, no dependencies)
   Config lives in snippets/hc-gift-finder.liquid (#hc-gf-config).
   Pure helpers are exposed on window.HawcrestGF for testing. */
(function () {
  'use strict';

  /* ---------- shared modal helper (also defined by hc-size-assistant.js) ---------- */
  if (!window.HawcrestModal) {
    window.HawcrestModal = (function () {
      var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
      var active = null;
      function focusables(el) {
        return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) {
          return n.offsetWidth > 0 || n.offsetHeight > 0 || n === document.activeElement;
        });
      }
      function onKey(e) {
        if (!active) return;
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var list = focusables(active.dialog);
        if (!list.length) { e.preventDefault(); active.dialog.focus(); return; }
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === active.dialog)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      function open(modal, trigger) {
        if (!modal) return;
        if (active) close(true);
        var dialog = modal.querySelector('[role="dialog"]');
        active = { modal: modal, dialog: dialog, trigger: trigger || document.activeElement };
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hc-modal-open');
        document.addEventListener('keydown', onKey, true);
        setTimeout(function () {
          var target = dialog.querySelector('[data-hc-autofocus]') || dialog;
          try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
        }, 30);
      }
      function close(silent) {
        if (!active) return;
        var a = active;
        active = null;
        a.modal.hidden = true;
        a.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('hc-modal-open');
        document.removeEventListener('keydown', onKey, true);
        if (!silent && a.trigger && typeof a.trigger.focus === 'function' && document.contains(a.trigger)) {
          try { a.trigger.focus({ preventScroll: true }); } catch (err) { a.trigger.focus(); }
        }
        a.modal.dispatchEvent(new CustomEvent('hc:closed'));
      }
      function bindClose(modal) {
        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-hc-close]')) { e.preventDefault(); close(); }
        });
      }
      /* Refresh the theme cart and open the drawer after an AJAX add. */
      function afterAdd(item) {
        try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } })); } catch (e) {}
        close(true);
        setTimeout(function () {
          var drawer = document.getElementById('CartDrawer');
          var isOpen = drawer && (drawer.classList.contains('drawer--is-open') || drawer.classList.contains('is-open'));
          if (!isOpen) {
            var link = document.querySelector('.js-drawer-open-cart');
            if (link) link.click();
            else window.location.href = '/cart';
          }
        }, 450);
      }
      function addToCart(variantId) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status) throw new Error(data.description || data.message || 'add failed');
            return data;
          });
        });
      }
      return { open: open, close: close, bindClose: bindClose, afterAdd: afterAdd, addToCart: addToCart };
    })();
  }

  /* ---------- pure helpers ---------- */
  function hashString(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function seededRandom(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) >>> 0;
      var t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function minAvailablePrice(p) {
    var min = Infinity;
    (p.variants || []).forEach(function (v) {
      if (v.available === false) return;
      var price = parseFloat(v.price);
      if (!isNaN(price) && price < min) min = price;
    });
    return min;
  }
  function isAvailable(p) {
    return (p.variants || []).some(function (v) { return v.available !== false; });
  }
  function budgetLimit(budget) {
    if (budget === 'under-25') return 25;
    if (budget === 'under-50') return 50;
    if (budget === 'under-100') return 100;
    return Infinity;
  }
  function inBudget(p, budget) {
    return minAvailablePrice(p) < budgetLimit(budget);
  }
  /* lists: { interest: [...], who: [...], holiday: [...] } – arrays of products.
     Score: interest AND who = 3, interest only = 2, who only = 1, +1 holiday boost.
     Unavailable and over-budget products are dropped. Stable seeded shuffle within a score. */
  function scoreProducts(lists, answers) {
    var byId = {};
    function idSet(arr) { var s = {}; (arr || []).forEach(function (p) { s[p.id] = true; byId[p.id] = p; }); return s; }
    var inInterest = idSet(lists.interest);
    var inWho = idSet(lists.who);
    var inHoliday = {};
    (lists.holiday || []).forEach(function (p) { inHoliday[p.id] = true; });
    var out = [];
    Object.keys(byId).forEach(function (id) {
      var p = byId[id];
      var score = inInterest[id] && inWho[id] ? 3 : inInterest[id] ? 2 : inWho[id] ? 1 : 0;
      if (!score) return;
      if (answers.occasion === 'holiday' && inHoliday[id]) score += 1;
      if (!isAvailable(p) || !inBudget(p, answers.budget)) return;
      out.push({ product: p, score: score });
    });
    var rand = seededRandom(hashString([answers.who, answers.occasion, answers.budget, answers.interest].join('|')));
    out.sort(function (a, b) { return String(a.product.id) < String(b.product.id) ? -1 : 1; });
    out.forEach(function (o) { o.r = rand(); });
    out.sort(function (a, b) { return b.score - a.score || a.r - b.r; });
    return out.map(function (o) { return o.product; });
  }
  function formatMoney(dollars) {
    var n = parseFloat(dollars);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function singleVariantId(p) {
    var avail = (p.variants || []).filter(function (v) { return v.available !== false; });
    if ((p.variants || []).length === 1 && avail.length === 1) return avail[0].id;
    if (avail.length === 1) return avail[0].id;
    return null;
  }

  window.HawcrestGF = {
    hashString: hashString, seededRandom: seededRandom, minAvailablePrice: minAvailablePrice,
    inBudget: inBudget, budgetLimit: budgetLimit, scoreProducts: scoreProducts,
    formatMoney: formatMoney, sizedImage: sizedImage, singleVariantId: singleVariantId
  };

  if (typeof document === 'undefined') return;

  /* ---------- UI ---------- */
  function init() {
    var modal = document.getElementById('hc-gf');
    var cfgEl = document.getElementById('hc-gf-config');
    if (!modal || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var S = cfg.strings || {};
    var body = modal.querySelector('[data-hc-gf-body]');
    var bar = modal.querySelector('.hc-progress__bar');
    var questions = cfg.questions || [];
    var answers = {};
    var step = 0;
    var cache = {};

    window.HawcrestModal.bindClose(modal);

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function withMail(text, subject) {
      var mail = cfg.email || 'contact@hawcrest.com';
      var link = '<a href="mailto:' + esc(mail) + '?subject=' + subject + '">' + esc(mail) + '</a>';
      var t = esc(text);
      return t.indexOf(esc(mail)) > -1 ? t.replace(esc(mail), link) : t + ' ' + link;
    }
    function progress(i) { if (bar) bar.style.width = Math.round((i / questions.length) * 100) + '%'; }

    function renderStep() {
      var q = questions[step];
      progress(step);
      var html = '<p class="hc-step__count">' + esc((S.step_of || 'Step {n} of {total}').replace('{n}', step + 1).replace('{total}', questions.length)) + '</p>';
      html += '<p class="hc-step__label" id="hc-gf-q">' + esc(q.label) + '</p>';
      html += '<ul class="hc-options" role="list" aria-labelledby="hc-gf-q">';
      q.options.forEach(function (o, i) {
        var pressed = answers[q.id] === o.value;
        html += '<li><button type="button" class="hc-option" data-value="' + esc(o.value) + '" aria-pressed="' + pressed + '"' + (i === 0 ? ' data-hc-autofocus' : '') + '>' + esc(o.label) + '</button></li>';
      });
      html += '</ul>';
      if (step > 0) html += '<div class="hc-nav"><button type="button" class="hc-link" data-hc-back>' + esc(S.back || 'Back') + '</button></div>';
      body.innerHTML = html;
      var firstBtn = body.querySelector('.hc-option');
      if (firstBtn && modal.hidden === false) firstBtn.focus();
    }

    function fetchCollection(handle) {
      if (!handle) return Promise.resolve([]);
      if (cache[handle]) return cache[handle];
      cache[handle] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { delete cache[handle]; return []; });
      return cache[handle];
    }

    function showResults() {
      progress(questions.length);
      body.innerHTML = '<p class="hc-loading" role="status">' + esc(S.loading || 'Finding gift ideas…') + '</p>';
      var whoHandle = (cfg.who_map || {})[answers.who];
      var interestHandle = (cfg.interest_map || {})[answers.interest];
      var holidayHandle = answers.occasion === 'holiday' ? cfg.holiday_handle : null;
      Promise.all([fetchCollection(interestHandle), fetchCollection(whoHandle), fetchCollection(holidayHandle)])
        .then(function (res) {
          var lists = { interest: res[0], who: res[1], holiday: res[2] };
          var picks = scoreProducts(lists, answers);
          if (picks.length >= 3) return picks;
          return fetchCollection(cfg.fallback_handle).then(function (fb) {
            var extra = scoreProducts({ interest: fb, who: [], holiday: res[2] }, answers);
            var seen = {};
            picks.forEach(function (p) { seen[p.id] = true; });
            extra.forEach(function (p) { if (!seen[p.id]) { picks.push(p); seen[p.id] = true; } });
            return picks;
          });
        })
        .then(function (picks) { renderResults(picks.slice(0, 6)); })
        .catch(function () { renderResults([]); });
    }

    function renderResults(picks) {
      var html = '<p class="hc-step__label" id="hc-gf-results-title" tabindex="-1">' + esc(S.results_title || 'Our picks for you') + '</p>';
      if (picks.length) {
        html += '<ul class="hc-results" role="list">';
        picks.forEach(function (p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          var url = '/products/' + p.handle;
          var vid = singleVariantId(p);
          html += '<li class="hc-card">';
          html += '<a class="hc-card__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(sizedImage(img, 400)) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</a>';
          html += '<div class="hc-card__body"><a class="hc-card__title" href="' + esc(url) + '">' + esc(p.title) + '</a>';
          html += '<span class="hc-card__price">' + esc(formatMoney(minAvailablePrice(p))) + '</span>';
          if (vid) html += '<button type="button" class="hc-btn" data-hc-add="' + esc(vid) + '">' + esc(S.add_to_cart || 'Add to cart') + '</button>';
          else html += '<a class="hc-btn hc-btn--ghost" href="' + esc(url) + '">' + esc(S.choose_options || 'Choose options') + '</a>';
          html += '<p class="hc-msg" role="alert" hidden></p></div></li>';
        });
        html += '</ul>';
      }
      if (picks.length < 3) html += '<p class="hc-note">' + esc(S.empty_text || 'We could not find enough matches for that combination. Try a different budget or interest.') + '</p>';
      html += '<p class="hc-note">' + withMail(S.advice_text || 'Still not sure? Email us and we\'ll help you pick — we reply within 1 business day.', 'Gift%20help') + '</p>';
      html += '<div class="hc-nav"><button type="button" class="hc-link" data-hc-back>' + esc(S.back || 'Back') + '</button><button type="button" class="hc-btn hc-btn--ghost" data-hc-restart>' + esc(S.restart_label || 'Start over') + '</button></div>';
      body.innerHTML = html;
      var t = document.getElementById('hc-gf-results-title');
      if (t) t.focus();
    }

    body.addEventListener('click', function (e) {
      var opt = e.target.closest('.hc-option');
      if (opt) {
        var q = questions[step];
        answers[q.id] = opt.getAttribute('data-value');
        if (step < questions.length - 1) { step++; renderStep(); }
        else { step = questions.length; showResults(); }
        return;
      }
      if (e.target.closest('[data-hc-back]')) {
        step = Math.max(0, Math.min(step, questions.length) - 1);
        renderStep();
        return;
      }
      if (e.target.closest('[data-hc-restart]')) { answers = {}; step = 0; renderStep(); return; }
      var add = e.target.closest('[data-hc-add]');
      if (add) {
        var msg = add.parentNode.querySelector('.hc-msg');
        add.disabled = true;
        add.textContent = S.adding || 'Adding…';
        window.HawcrestModal.addToCart(add.getAttribute('data-hc-add'))
          .then(function (item) {
            add.textContent = S.added || 'Added';
            setTimeout(function () { window.HawcrestModal.afterAdd(item); }, 350);
          })
          .catch(function () {
            add.disabled = false;
            add.textContent = S.add_to_cart || 'Add to cart';
            if (msg) { msg.hidden = false; msg.textContent = S.error || 'Sorry, this item could not be added. Please try again.'; }
          });
      }
    });

    function openFinder(trigger) {
      var preset = trigger && trigger.getAttribute ? trigger.getAttribute('data-hc-who') : null;
      var whoQ = questions[0];
      var valid = preset && whoQ && whoQ.options.some(function (o) { return o.value === preset; });
      if (valid) {
        answers = {};
        answers[whoQ.id] = preset;
        step = 1;
        renderStep();
      } else if (step < questions.length) {
        renderStep();
      }
      window.HawcrestModal.open(modal, trigger);
      if (step < questions.length) { var b = body.querySelector('.hc-option'); if (b) setTimeout(function () { b.focus(); }, 40); }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-hc-open="gift-finder"]');
      var link = !trigger && e.target.closest('a[href]');
      if (link) {
        var href = link.getAttribute('href') || '';
        if (/#gift-finder$/.test(href)) trigger = link;
        else link = null;
      }
      if (!trigger) return;
      e.preventDefault();
      openFinder(trigger);
    });

    renderStep();
    if (window.location.hash === '#gift-finder') openFinder(null);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
